import useCooperationHooks from './hooks'
import { Row, Col, Space, Button } from 'antd'
import styles from './return-order.module.scss'
import { renderStateInfo, returnStateColorDict, stateKey } from '../orderdetail'
import { Link } from 'react-router-dom'
import { returnStateEnum } from '../../tools/state'
import CustomTable from '../../components/CustomTable'
const ReturnOrderDetail = () => {
  const { infoObj: detailInfo, isTableLoading } = useCooperationHooks()

  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }

  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
    },
    {
      key: 'code',
      dataIndex: 'code',
      title: '物料编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '商品名称',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '规格型号',
    },
    {
      key: 'reCount',
      dataIndex: 'reCount',
      title: '退货数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '单价',
    },
  ]

  return (
    <div className={styles['container']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          <Row
            justify="space-between"
            style={{
              width: '100%',
            }}
          >
            <Space>
              <span>客户订单号：{detailInfo?.orderNo}</span>
              <div>
                状态：
                {renderStateInfo(detailInfo?.orderState as stateKey)}
              </div>
            </Space>
            <Link to={`/srm/orderdetail?id=${detailInfo?.orderId}`}>
              <Button size="middle">查看详情</Button>
            </Link>
          </Row>
        </div>
        <div className={styles['content']}>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                客户名称：{detailInfo?.customer}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单时间：{detailInfo?.createTime}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单平台：{detailInfo?.platform}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                发货进度：{detailInfo?.progress}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单金额：{detailInfo?.price}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                退货金额：{detailInfo?.refundPrice}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                最终结算金额：{' '}
                {detailInfo?.orderState === '已完成'
                  ? detailInfo?.settlePrice
                  : '待订单完成后计算'}
              </div>
            </Col>
          </Row>
        </div>
        <div className={styles['delivery-container']}>
          <div className={styles['info-container']}>
            <Row>
              <Space>
                <div className={styles['title']}>退货单1</div>
                <span className={styles['title']}>
                  时间：{detailInfo?.returnTime}
                </span>
              </Space>
            </Row>
            <Row justify="space-between">
              <div>退货单编号：{detailInfo?.orderReturnNo}</div>
              <div>退货金额：{detailInfo?.refundPrice}</div>
              <div>
                <span>状态：</span>
                <span
                  style={{
                    color:
                      returnStateColorDict?.[
                        (detailInfo?.orderState as any) ?? '默认'
                      ],
                  }}
                >
                  {returnStateEnum.getDisplayTextByLabel(
                    detailInfo?.orderState as any,
                  )}
                </span>
              </div>
              <div></div>
            </Row>
          </div>
          <CustomTable
            rowKey={'code'}
            dataSource={detailInfo?.productList ?? []}
            isLoading={isTableLoading}
            columns={listColumn}
          ></CustomTable>
        </div>
      </div>
    </div>
  )
}

export default ReturnOrderDetail
import useCooperationHooks from './hooks'
import { Row, Col, Space, Button } from 'antd'
import styles from './return-order.module.scss'
import { renderStateInfo, returnStateColorDict, stateKey } from '../orderdetail'
import { Link } from 'react-router-dom'
import { returnStateEnum } from '../../tools/state'
import CustomTable from '../../components/CustomTable'
const ReturnOrderDetail = () => {
  const { infoObj: detailInfo, isTableLoading } = useCooperationHooks()

  const orderNoRender = (text: any, record: any, index: number) => {
    return index + 1 + ''
  }

  const listColumn = [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      render: orderNoRender,
    },
    {
      key: 'code',
      dataIndex: 'code',
      title: '物料编码',
    },
    {
      key: 'brand',
      dataIndex: 'brand',
      title: '品牌',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '商品名称',
    },
    {
      key: 'model',
      dataIndex: 'model',
      title: '规格型号',
    },
    {
      key: 'reCount',
      dataIndex: 'reCount',
      title: '退货数量',
    },
    {
      key: 'unit',
      dataIndex: 'unit',
      title: '单位',
    },
    {
      key: 'price',
      dataIndex: 'price',
      title: '单价',
    },
  ]

  return (
    <div className={styles['container']}>
      <div className={styles['order-info']}>
        <div className={styles['header']}>
          <Row
            justify="space-between"
            style={{
              width: '100%',
            }}
          >
            <Space>
              <span>客户订单号：{detailInfo?.orderNo}</span>
              <div>
                状态：
                {renderStateInfo(detailInfo?.orderState as stateKey)}
              </div>
            </Space>
            <Link to={`/srm/orderdetail?id=${detailInfo?.orderId}`}>
              <Button size="middle">查看详情</Button>
            </Link>
          </Row>
        </div>
        <div className={styles['content']}>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                客户名称：{detailInfo?.customer}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单时间：{detailInfo?.createTime}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单平台：{detailInfo?.platform}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                发货进度：{detailInfo?.progress}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                下单金额：{detailInfo?.price}
              </div>
            </Col>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                退货金额：{detailInfo?.refundPrice}
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <div className={styles['info-text-container']}>
                最终结算金额：{' '}
                {detailInfo?.orderState === '已完成'
                  ? detailInfo?.settlePrice
                  : '待订单完成后计算'}
              </div>
            </Col>
          </Row>
        </div>
        <div className={styles['delivery-container']}>
          <div className={styles['info-container']}>
            <Row>
              <Space>
                <div className={styles['title']}>退货单1</div>
                <span className={styles['title']}>
                  时间：{detailInfo?.returnTime}
                </span>
              </Space>
            </Row>
            <Row justify="space-between">
              <div>退货单编号：{detailInfo?.orderReturnNo}</div>
              <div>退货金额：{detailInfo?.refundPrice}</div>
              <div>
                <span>状态：</span>
                <span
                  style={{
                    color:
                      returnStateColorDict?.[
                        (detailInfo?.orderState as any) ?? '默认'
                      ],
                  }}
                >
                  {returnStateEnum.getDisplayTextByLabel(
                    detailInfo?.orderState as any,
                  )}
                </span>
              </div>
              <div></div>
            </Row>
          </div>
          <CustomTable
            rowKey={'code'}
            dataSource={detailInfo?.productList ?? []}
            isLoading={isTableLoading}
            columns={listColumn}
          ></CustomTable>
        </div>
      </div>
    </div>
  )
}

export default ReturnOrderDetail
